import milestones from '~/pages/milestones/shared';

document.addEventListener('DOMContentLoaded', milestones);
